module.exports = __webpack_public_path__ + "img/crew_adv_01.713f3f26.png";